import { table_grid_columns } from '../../assets/js/field_config/gantt-columns';
import * as ganttActions from '../../redux/slices/ganttSlice';
import masterplanPermissions from '../../hooks/useMasterplanPermissions';
import { cleanColumnsIssues } from '../ganttContainer/gantt/viewUtils';
import { store } from '../../redux/store';

export function configureColumns(gantt, t, dispatch) {
  const ganttState = store.getState().ganttState;
  const { gridTable } = ganttState.userPreferenceTableGantt;
  const columnsByDefault = table_grid_columns(gantt, t, masterplanPermissions);

  let copyOfTableData = !gridTable?.length ? [...columnsByDefault] : gridTable;

  const cleanedColumnsToLoadView = cleanColumnsIssues(copyOfTableData);
  let flag = false;

  if (cleanedColumnsToLoadView) {
    flag = cleanedColumnsToLoadView.some((el, idx) => {
      if (columnsByDefault[idx]) {
        return el.filterable !== columnsByDefault[idx].filterable;
      }
      return false;
    });
  }

  copyOfTableData = cleanedColumnsToLoadView;

  copyOfTableData.map((column, idx) => {
    if (flag) {
      column.filterable = columnsByDefault[idx]?.filterable;
    }

    if (column.name !== 'buttons') {
      if (
        column.data_type.includes('/icon') ||
        column.data_type.includes('/string')
      ) {
        column.label = t('tables.gantt.' + column.name + '.label');
        if (!column.data_type.includes('array/string')) {
          column.from_values.map((option) => {
            option.label = t(
              'tables.gantt.' + column.name + '.options.' + option.value
            );
          });
        }
      } else {
        column.label = t('tables.gantt.' + column.name);
      }
    }
  });

  if (!gridTable?.length) {
    dispatch(
      ganttActions.setUserPreferenceTableGantt({
        table: copyOfTableData,
        ganttChart: null
      })
    );
  }
}
